(function () {
  document.querySelectorAll('[data-slcv]').forEach(function (root) {
    var links = Array.from(root.querySelectorAll('[data-slcv-nav]'));
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('is-visible');
      });
    }, { threshold: 0.14 });
    root.querySelectorAll('.slcv-reveal').forEach(function (item) { observer.observe(item); });

    var sections = Array.from(root.querySelectorAll('[data-slcv-section]'));
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
        });
      });
    }, { rootMargin: '-35% 0px -55% 0px' });
    sections.forEach(function (section) { sectionObserver.observe(section); });
  });
})();
